import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlreadyHaveTrailerAttached = _resolveComponent("AlreadyHaveTrailerAttached")!
  const _component_EnterTrailerOverlay = _resolveComponent("EnterTrailerOverlay")!
  const _component_TrailerPlateVinVerification = _resolveComponent("TrailerPlateVinVerification")!
  const _component_ScanTrailer = _resolveComponent("ScanTrailer")!
  const _component_TrailerLookup = _resolveComponent("TrailerLookup")!
  const _component_UnsupportedTrailerTypeOverlay = _resolveComponent("UnsupportedTrailerTypeOverlay")!
  const _component_ReportQrUnassociated = _resolveComponent("ReportQrUnassociated")!
  const _component_UnassociatedQrCodeOverlay = _resolveComponent("UnassociatedQrCodeOverlay")!
  const _component_SomethingWrongOverlay = _resolveComponent("SomethingWrongOverlay")!
  const _component_DriverLoaded = _resolveComponent("DriverLoaded")!
  const _component_LoadingModal = _resolveComponent("LoadingModal")!
  const _component_ReturnOptions = _resolveComponent("ReturnOptions")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.alreadyAttached && !_ctx.detachModalHidden)
      ? (_openBlock(), _createBlock(_component_AlreadyHaveTrailerAttached, {
          key: 0,
          attachedTrailers: _ctx.currentAttachedTrailers,
          promptStillNearTrailer: true,
          onOnDetach: _ctx.confirmTrailerResult,
          onOnSearchForTrailers: _ctx.hideAttachModal
        }, null, 8, ["attachedTrailers", "onOnDetach", "onOnSearchForTrailers"]))
      : _createCommentVNode("", true),
    (!!_ctx.attachability && _ctx.showConfirm)
      ? (_openBlock(), _createBlock(_component_EnterTrailerOverlay, {
          key: 1,
          trailerIsAvailable: _ctx.attachability?.canAttach,
          companyMismatch: _ctx.isCompanyMismatch,
          onOnAccept: _ctx.acceptConfirm,
          onOnReject: _ctx.rejectConfirm,
          onOnBackToScan: _ctx.onBackToScan
        }, null, 8, ["trailerIsAvailable", "companyMismatch", "onOnAccept", "onOnReject", "onOnBackToScan"]))
      : _createCommentVNode("", true),
    (_ctx.verifyPlateVin)
      ? (_openBlock(), _createBlock(_component_TrailerPlateVinVerification, {
          key: 2,
          trailer: _ctx.trailer,
          onAttachVerified: _ctx.trailerLocationVerified,
          onGoBack: _ctx.onBackToScan
        }, null, 8, ["trailer", "onAttachVerified", "onGoBack"]))
      : _createCommentVNode("", true),
    (_ctx.showScanner && !_ctx.showReportQrOverlay)
      ? (_openBlock(), _createBlock(_component_ScanTrailer, {
          key: 3,
          isScannerPaused: _ctx.isScannerPaused,
          onOnCloseScanner: _ctx.onCloseScanner,
          onOnManualAttach: _ctx.onManualAttach,
          onOnScanned: _ctx.onScanned,
          onOnScanError: _ctx.onScanError
        }, null, 8, ["isScannerPaused", "onOnCloseScanner", "onOnManualAttach", "onOnScanned", "onOnScanError"]))
      : (!_ctx.showScanner)
        ? (_openBlock(), _createBlock(_component_TrailerLookup, {
            key: 4,
            headLineText: "Enter Trailer Number",
            scannerButtonEnabled: _ctx.isCameraAvailable,
            showCameraSettings: _ctx.showCameraSettings,
            onOnToggleScanner: _ctx.onToggleScanner,
            onOnSearchTrailer: _ctx.onSearchTrailer
          }, null, 8, ["scannerButtonEnabled", "showCameraSettings", "onOnToggleScanner", "onOnSearchTrailer"]))
        : _createCommentVNode("", true),
    (_ctx.showUnsupportedTypeOverlay)
      ? (_openBlock(), _createBlock(_component_UnsupportedTrailerTypeOverlay, {
          key: 5,
          goBackText: "Search for Trailers",
          closeModalText: "Scan Again",
          goBackFunction: _ctx.navigateToDriverLanding,
          closeModalFunction: _ctx.closeErrorModal
        }, null, 8, ["goBackFunction", "closeModalFunction"]))
      : (_ctx.showReportQrOverlay)
        ? (_openBlock(), _createBlock(_component_ReportQrUnassociated, {
            key: 6,
            scannedQrId: _ctx.scannedQrId,
            onOnAttachTrailer: _ctx.onSearchTrailer,
            onOnReturnToScan: _ctx.closeErrorModal,
            onHideBackButton: _ctx.hideBackButton
          }, null, 8, ["scannedQrId", "onOnAttachTrailer", "onOnReturnToScan", "onHideBackButton"]))
        : (_ctx.showUnassociatedQrOverlay)
          ? (_openBlock(), _createBlock(_component_UnassociatedQrCodeOverlay, {
              key: 7,
              goToManualTrailerEntryFunction: _ctx.onManualAttach
            }, null, 8, ["goToManualTrailerEntryFunction"]))
          : (_ctx.hasError && !_ctx.isDetachError)
            ? (_openBlock(), _createBlock(_component_SomethingWrongOverlay, {
                key: 8,
                customBackFunc: _ctx.closeErrorModal,
                message: _ctx.error?.message
              }, null, 8, ["customBackFunc", "message"]))
            : _createCommentVNode("", true),
    (_ctx.showLoadedTrailerModal)
      ? (_openBlock(), _createBlock(_component_DriverLoaded, {
          key: 9,
          attachedTrailerNumber: _ctx.currentAttachedTrailerNumber,
          attachedTrailerCompany: _ctx.currentAttachedTrailerCompany,
          showDeepLinkButton: true,
          onOnSearchForTrailers: _ctx.navigateToDriverLanding,
          association: "attach"
        }, null, 8, ["attachedTrailerNumber", "attachedTrailerCompany", "onOnSearchForTrailers"]))
      : _createCommentVNode("", true),
    (_ctx.showLoading || _ctx.attachabilityLoading)
      ? (_openBlock(), _createBlock(_component_LoadingModal, { key: 10 }))
      : _createCommentVNode("", true),
    (!_ctx.showReportQrOverlay)
      ? (_openBlock(), _createBlock(_component_ReturnOptions, { key: 11 }))
      : _createCommentVNode("", true)
  ]))
}